var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvayaMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 30,
    viewBox: "0 0 67 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5022 8.34679H55.3489L55.972 9.88613H50.7814L49.9494 11.6545H47.6589L53.3447 0H54.9312L60.617 11.6545H58.3265L54.1363 2.65763L51.5022 8.34679Z",
    fill: "#DA291C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09415 8.43034H11.9408L12.564 9.97305H7.36995L6.54134 11.7414H4.25085L9.93664 0.0869141H11.5231L17.2089 11.7414H14.9184L10.7282 2.74118L8.09415 8.43034Z",
    fill: "#DA291C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7157 8.43034H33.5658L34.1889 9.97305H28.9949L28.1663 11.7414H25.8724L31.5582 0.0869141H33.1481L38.8339 11.7414H36.54L32.3532 2.74118L29.7157 8.43034Z",
    fill: "#DA291C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0667 0.0478516L20.7524 11.7057H20.8468H22.2413H22.3389L28.0247 0.0478516H25.7342L21.544 9.21989L17.3571 0.0478516H15.0667Z",
    fill: "#DA291C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0066 16.0812L49.8549 0.0478516H47.5678L43.2058 9.39168L39.1873 0.0478516H36.8969L42.0673 11.7057L39.8138 16.0812H42.0066Z",
    fill: "#DA291C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvayaMobileLogo);
export default __webpack_public_path__ + "static/media/avaya-mobile-logo.c5017978ccd5378ce8b4d2aee8a26dde.svg";
export { ForwardRef as ReactComponent };